module.exports = __webpack_public_path__ + "static/media/PlutoRegular.21b099ee.woff";